(function moveVPTable() {
  function doMove() {
    const bssBlock = document.querySelector('.bss-b2b-cart-item-qty-table');
    const variantSection = document.querySelector('gp-product-variants');
    if (!bssBlock || !variantSection) return false;

    if (variantSection.nextElementSibling === bssBlock) return true;
    variantSection.insertAdjacentElement('afterend', bssBlock);
    return true;
  }

  if (doMove()) return;

  const observer = new MutationObserver(() => {
    if (doMove()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 15000);
})();